import { z } from 'zod';

/**
 * User Review Schema
 * Product reviews with moderation system
 */
export const ZUserReview = z.object({
  id: z.string().uuid(),
  product_id: z.string().uuid(),
  user_id: z.string().uuid(),
  rating: z.number().int().min(1).max(5),
  title: z.string().min(3, "Title must be at least 3 characters").max(200, "Title must be less than 200 characters").trim(),
  content: z.string().min(10, "Review must be at least 10 characters").max(2000, "Review must be less than 2000 characters").trim(),
  verified_purchase: z.boolean().default(false),
  is_approved: z.boolean().default(false),
  approved_by: z.string().uuid().nullable(),
  approved_at: z.string().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const ZUserReviewInsert = z.object({
  product_id: z.string().uuid(),
  user_id: z.string().uuid(),
  rating: z.number().int().min(1, "Please select a rating between 1-5").max(5),
  title: z.string()
    .min(3, "Title must be at least 3 characters")
    .max(200, "Title must be less than 200 characters")
    .trim()
    .refine(val => val.length > 0, "Title cannot be empty"),
  content: z.string()
    .min(10, "Review must be at least 10 characters")
    .max(2000, "Review must be less than 2000 characters")
    .trim()
    .refine(val => val.length > 0, "Review content cannot be empty"),
});

export const ZUserReviewUpdate = z.object({
  rating: z.number().int().min(1).max(5).optional(),
  title: z.string().min(3).max(200).trim().optional(),
  content: z.string().min(10).max(2000).trim().optional(),
});

export const ZReviewApproval = z.object({
  is_approved: z.boolean(),
  approved_by: z.string().uuid(),
  approved_at: z.string(),
});

export const ZReviewWithUser = ZUserReview.extend({
  user_email: z.string().email().nullable(),
  user_full_name: z.string().nullable(),
  user_avatar_url: z.string().nullable(),
});

export type UserReview = z.infer<typeof ZUserReview>;
export type UserReviewInsert = z.infer<typeof ZUserReviewInsert>;
export type UserReviewUpdate = z.infer<typeof ZUserReviewUpdate>;
export type ReviewApproval = z.infer<typeof ZReviewApproval>;
export type ReviewWithUser = z.infer<typeof ZReviewWithUser>;
